<template>
  <div>
    <Breadcrumbs title="User Management" />
    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} User`">
          <div class="row">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.name.match('Email')
                                ? 'required|email|customRegexCRLF|max_length200'
                                : form.validate
                                  ? 'required|customRegex|customRegexCRLF|max_length200'
                                  : null
                              " v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <b-form-input :disabled="modalData.disable ||
                                      (modalData.title == 'Edit' &&
                                        (form.name == 'First Name' ||
                                          form.name == 'Last Name' ||
                                          form.name == 'Email'))
                                      " v-model="form.value" :id="form.name"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12">
              <b-form-group label="Access App" label-for="email">
                <div v-for="(item, i) in access" :key="i" class="row">
                  <template v-if="checkPermisson(item)">
                    <div class="checkbox-animated pl-3 col-6">
                      <label class="d-block mt-2 mb-3" :for="item.checkbox + i">
                        <input :disabled="modalData.disable" class="checkbox_animated" :id="item.checkbox + i"
                          type="checkbox" @change="deselect(i)" v-model="item.check" />
                        {{ item.checkbox }}
                      </label>
                    </div>
                    <div class="col-6">
                      <div class="row">
                        <div class="col-2 pt-2">Role:</div>
                        <div class="col-10 mb-2">
                          <v-select :disabled="!item.check || modalData.disable" sm v-model="item.role" label="Role"
                            :options="['Admin', 'Agent']" />
                          <!-- <span
                                                  style="font-size: smaller"
                                                  class="font-weight-lighter text-danger"
                                                  >{{ errors }}
                                                </span> -->
                          <!-- <ValidationProvider

                                                    :name="item.checkbox + 'Role'"
                                                    :rules="item.check ? 'required' : null"
                                                    v-slot="{ errors }"
                                                >
                                                check:{{item.check}}
                                                    <v-select
                                                      :disabled="!item.check || modalData.disable"
                                                      sm
                                                      v-model="item.role"
                                                      label="Role"
                                                      :options="['Admin', 'Agent']"
                                                    />
                                                    <span
                                                      style="font-size: smaller"
                                                      class="font-weight-lighter text-danger"
                                                      >{{ errors }}
                                                    </span>
                                                </ValidationProvider> -->
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </b-form-group>
            </div>
          </div>
          <template #modal-footer>
            <b-button variant="primary" :disabled="invalid || Accessible" @click="save(modalData)"><i
                class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>
      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" v-bind:data="{
                  module: 'auth',
                  columns: columns,
                  rows: rows,
                  filter_col: [0, 3],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @status="status" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      active: true,
      show: false,
      form: [
        {
          value: '',
          col: 6,
          name: 'First Name',
          type: 'input',
          validate: true,
        },
        {
          value: '',
          col: 6,
          name: 'Last Name',
          type: 'input',
          validate: true,
        },
        {
          value: '',
          col: 12,
          name: 'Agent ID',
          type: 'input',
          validate: true,
        },
        {
          value: '',
          col: 12,
          name: 'Sender',
          type: 'input',
          validate: true,
        },
        {
          value: '',
          col: 12,
          name: 'Email',
          type: 'input',
          validate: true,
        },
      ],
      access: [
        {
          checkbox: 'Email',
          check: false,
          role: null,
        },
        {
          checkbox: 'Beacon',
          check: false,
          role: null,
        },
      ],

      columns: [
        {
          label: 'Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Email',
          field: 'email',
          hidden: false,
        },
        {
          label: 'Agent ID',
          field: 'agent_id',
          hidden: false,
        },
        // {
        //   label: 'Role',
        //   field: 'Role',
        //   hidden: false,
        // },
      ],
      rows: [],
      status_beacon: false,
      status_ccp: false,
    };
  },
  computed: {
    Accessible() {
      let boo = false;
      if (!this.access[0].check && !this.access[1].check) {
        return true;
      }
      this.access.forEach((element) => {
        if (element.check) {
          if (element.role == null) {
            boo = true;
          }
        }
      });
      return boo;
    },
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  async created() {
    // this.loadColumn();
    this.initRoleUser();
  },
  mounted() {
    this.$refs.refDataTable.loadItems()
  },
  methods: {
    checkPermisson(value) {
      let isShow = false;
      switch (value.checkbox) {
        case 'Email':
          isShow = this.status_ccp ? true : false;
          break;
        case 'Beacon':
          isShow = this.status_beacon ? true : false;
          break;
        default:
        // code block
      }
      return isShow;
    },
    initRoleUser() {
      let userinfo = localStorage.getItem('userinfo');
      userinfo = JSON.parse(userinfo);
      if (
        userinfo.role_beacon != undefined &&
        (userinfo.role_beacon == 'admin' || userinfo.role_beacon == 'Admin')
      ) {
        this.status_beacon = true;
        this.columns.push({
          label: 'Beacon',
          field: 'role_beacon',
          hidden: false,
        });
      }
      if (
        userinfo.role_ccp != undefined &&
        (userinfo.role_ccp == 'admin' || userinfo.role_ccp == 'Admin')
      ) {
        this.status_ccp = true;
        this.columns.push({
          label: 'Email',
          field: 'role_ccp',
          hidden: false,
        });
      }
      this.columns.push({
        label: 'Status',
        field: 'status',
        hidden: false,
      });
      this.columns.push({
        label: 'SMS Sender Name',
        field: 'sender',
        hidden: false,
      });
      this.columns.push({
        label: 'Action',
        field: 'action',
        thClass: 'custom-th-class',
        hidden: false,
      });
    },
    deleteRow(value) {
      const url = `/api/user/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('auth', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.$refs.refDataTable.loadItems()
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    status(id, value) {
      const url = `/api/user/active/${id.row._id}`;
      const object = {
        status: value ? 'Enable' : 'Disable',
      };
      requestService
        .PostFetch('auth', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Status has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.$refs.refDataTable.loadItems()
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    save(value) {
      let data = this.form
        .map((item) => item.value)
        .concat(this.access.map((item) => item.role));
      // let role = ;
      this.show = !this.show;
      const url = `/api/user${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      const object = {
        agent_id: data[2],
        name: `${data[0]}:${data[1]}`,
        sender: data[3],
        email: data[4],
        role_ccp: data[5],
        role_beacon: data[6],
        status: this.active ? 'Enable' : 'Disable',
      };
      requestService
        .PostFetch('auth', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'User has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
          this.access.map((item, i) => {
            this.access[i].check = false;
            this.access[i].role = null;
          });
          this.$refs.refDataTable.loadItems()
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    deselect(i) {
      this.access[i].role = null;
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;
      this.show = !this.show;
      if (!value.match('Add')) {
        let name = id.row.name.split(':');
        this.form[0].value = name[0];
        this.form[1].value = name[1];
        this.form[2].value = id.row.agent_id;
        this.form[3].value = id.row.sender;
        this.form[4].value = id.row.email;
        this.access[0].check = id.row.role_ccp ? true : false;
        this.access[1].check = id.row.role_beacon ? true : false;

        this.access[0].role = id.row.role_ccp;
        this.access[1].role = id.row.role_beacon;
        this.active = id.row.status.match('Enable');
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }

      const requestOptions = {
        method: 'GET',
      };
      var url = '/api/user/filter?' + str;

      return requestService
        .GetFetch('auth', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style>
.rounded-1 {
  border-radius: 1rem !important;
}
</style>
